var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.467119,
    y: 0.467119,
    width: 11.0658,
    height: 11.0658,
    rx: 5.53288,
    fill: "url(#paint0_linear_299_17397)",
    stroke: "url(#paint1_linear_299_17397)",
    strokeWidth: 0.934238
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3167 7.66779C9.27729 7.81457 9.20002 7.94842 9.09262 8.05596C8.98523 8.16349 8.85147 8.24092 8.70474 8.28052C8.16465 8.42578 5.99964 8.42578 5.99964 8.42578C5.99964 8.42578 3.83462 8.42578 3.29453 8.28129C3.14774 8.24183 3.01391 8.16443 2.9065 8.05688C2.79908 7.94933 2.72186 7.81541 2.68257 7.66857C2.53809 7.1277 2.53809 5.99961 2.53809 5.99961C2.53809 5.99961 2.53809 4.87151 2.68257 4.33142C2.76216 4.03317 2.99705 3.79828 3.29453 3.71869C3.83462 3.57343 5.99964 3.57343 5.99964 3.57343C5.99964 3.57343 8.16465 3.57343 8.70474 3.71869C9.00299 3.79828 9.23711 4.03317 9.3167 4.33142C9.46118 4.87151 9.46118 5.99961 9.46118 5.99961C9.46118 5.99961 9.46118 7.1277 9.3167 7.66779ZM5.31196 4.96423V7.03498L7.10455 6.00733L5.31196 4.96423Z",
    fill: "#565656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_17397",
    x1: 6,
    y1: -2.16,
    x2: 6,
    y2: 13.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_299_17397",
    x1: 6,
    y1: -2.16,
    x2: 6,
    y2: 13.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg7);
export default __webpack_public_path__ + "static/media/img7.f30f4cb060a426e2dbf94889d826e0ad.svg";
export { ForwardRef as ReactComponent };